// src/utils/logger.js
// Conditional logging utility for development vs production

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  // General logging
  log: (message, data) => {
    if (isDevelopment) {
      console.log(message, data);
    }
  },

  // Error logging (always log errors)
  error: (message, error) => {
    console.error(message, error);
  },

  // Warning logging (always log warnings)
  warn: (message, data) => {
    console.warn(message, data);
  },

  // Debug logging (only in development)
  debug: (message, data) => {
    if (isDevelopment) {
      console.log(`[DEBUG] ${message}`, data);
    }
  },

  // API logging (only in development)
  api: (message, data) => {
    if (isDevelopment) {
      console.log(`[API] ${message}`, data);
    }
  },

  // Performance logging (only in development)
  perf: (message, data) => {
    if (isDevelopment) {
      console.log(`[PERF] ${message}`, data);
    }
  },

  // Group logging for better organization
  group: (label, fn) => {
    if (isDevelopment) {
      console.group(label);
      fn();
      console.groupEnd();
    } else {
      fn();
    }
  }
};

export default logger;
